import {http} from './config';

import axios from 'axios';

// return http.post('autenticar',usuario)
export default{


    eliminarTotalUsuario:(identificador)=>{
              
        console.log(identificador);
        return  http.delete('/api/destroy_user/'+identificador);
    },

    sendNewPass:(user)=>{
              
        console.log(user);
        return  http.post('/api/change',user);
    },

recibirCorreo:(url,user)=>{
              
    // console.log(url,user);
     return  http.post('/api/email/verify'+url,user);
 },
verificarCorreo:(tokenObject)=>{
              
    // console.log(url,user);
     return  http.post('/api/email/verify/send',tokenObject);
 },

    passChange:(url,user)=>{
              
       // console.log(url,user);
        return  http.post('/api/password/reset'+url,user);
    },

    enviarCorreo:(user)=>{
              
        console.log(user);
        return  http.post('/api/password/email',user);
    },

   
    autenticar:(usuario)=>{
              
        console.log(usuario);
        return  http.post('/api/login',usuario, { skipAuthInterceptor: true });
    },
    logout:()=>{
              
        
        return  http.get('/api/logout');



    },
    //sin funcionar
    autenticarGoogle:()=>{
              
        return new Promise((resolve, reject) => {
            http
                .get('api/login/google')
                .then((response) => {

                    console.log(response);
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                })
        })
    }
    ,
    //sin funcionar
    autenticarGoogleCal:()=>{
              

        return  http.get('api/login/google/callback');
        
    }


} 









/*

export const useAuthStore = defineStore('auth',{
    state: () => ({ authUser: null, authToken: null }),
    getters:{ 
        user:(state) => state.authUser,
        token:(state) => state.authToken
    },
    actions:{
        async getToken(){
            await axios.get('/sanctum/csrf-cookie');
        },
        async login(form){
            await this.getToken();
            await axios.post('/api/auth/login',form).then(
                (res) => {
                    this.authToken = res.data.token;
                    this.authUser = res.data.data;
                    this.router.push('/departments');
                }
            ).catch(
                (errors) => {
                    let desc = '';
                    errors.response.data.errors.map(
                        (e) => {desc = desc + ' '+e}
                    )
                    show_alerta(desc,'error','');
                }
            )
        },
        async register(form){
            await this.getToken();
            await axios.post('/api/auth/register',form).then(
                (res) => {
                    show_alerta(res.data.message,'success','');
                    setTimeout( () => this.router.push('/login'), 2000);
                }
            ).catch(
                (errors) => {
                    let desc = '';
                    errors.response.data.errors.map(
                        (e) => {desc = desc + ' '+e}
                    )
                    show_alerta(desc,'error','');
                }
            )
        },
        async logout(){
            await axios.get('/api/auth/logout',this.authToken);
            this.authToken = null;
            this.authUser = null;
            this.router.push('/login');
        }
    },
    persist:true
});

*/